import { client as api } from '@/api';

// Chat Provider Configuration
export const CHAT_CONFIG = {
  serverUrl: import.meta.env.VITE_CX3_SERVER_URL || import.meta.env.VITE_CHAT_SERVER_URL || 'http://localhost:8080',
  tenantId: import.meta.env.VITE_CX3_TENANT_ID || import.meta.env.VITE_CHAT_TENANT_ID || 'apnasanatan',
};

/**
 * Fetch chat token for the current astrologer
 * This is provider-agnostic - the backend handles the actual provider integration
 */
export async function getChatToken(astrologerId, accessToken) {
  const response = await api.post(
    '/api/chat/token/astrologer',
    {},
    { headers: { Authorization: `Bearer ${accessToken}` } }
  );
  return response.data.data.token;
}

/**
 * Resolve user metadata for chat display
 * This is called by the chat SDK to get display names and avatars
 */
export async function resolveUser(userId) {
  try {
    if (userId.startsWith('user_')) {
      const id = userId.replace('user_', '');
      const response = await api.get(`/api/user/user/get/${id}`);
      const user = response.data;
      
      return {
        displayName: user.name || 'User',
        avatar: user.picture,
      };
    } else if (userId.startsWith('astro_')) {
      const id = userId.replace('astro_', '');
      const response = await api.get(`/api/astrologer/${id}`);
      const astrologer = response.data.data || response.data;
      
      return {
        displayName: astrologer.name || 'Astrologer',
        avatar: astrologer.picture,
        subtitle: astrologer.astrologerTypes?.join(', ') || 'Astrologer',
      };
    }
    
    // Fallback for unknown ID format
    return { displayName: userId };
  } catch (error) {
    console.error('[Chat] Error resolving user:', userId, error);
    return { displayName: userId };
  }
}
